import React, { useEffect, useState } from "react";
import DateSelector from "../../components/shared/fields/DateSelector";
import GridCard from "../../components/shared/gridCard/GridCard";
import KgEntered from "../../images/material_kg.svg";
import TotalCase from "../../images/totalCase.svg";
import TotalOrangeCase from "../../images/total_orange.svg";
import TabsComponent from "../../components/shared/tabs/TabsComponent";
import EmployeeAttendenceTab from "./EmployeeAttendanceTab";
import { useGetEmployeeAttendanceSummaryQuery } from "./employeeAttendanceApi";
import { useNavigate, useLocation } from "react-router-dom";
import { useGetWorkingAreasQuery } from "../../app/globalApi";
import {
  getAllowedTabsByRole,
  jwtDecode,
} from "../../helpers/AccessControlUtils";
import useTranslator from "../../hooks/useTranslator";
import { formatDateAndTime, getCurrentDate } from "../../helpers/Utils";
import { PROJECT_DATE_FORMAT } from "../../helpers/constants";

const currentDate = getCurrentDate("YYYY-MM-DD");
let allowedTabs = [];

const EmployeeAttendence = () => {
  const { _t } = useTranslator();
  const decodedToken = jwtDecode();
  const navigate = useNavigate();
  const location = useLocation();
  const [date, setDate] = useState(currentDate);
  const [activeKey, setActiveKey] = useState(null);
  const [tabsData, setTabsData] = useState([]);
  const { data: workingAreas, isLoading } = useGetWorkingAreasQuery();
  const { data: employeeAttendanceSummary, refetch } =
    useGetEmployeeAttendanceSummaryQuery(
      {
        date: date,
        working_area_id: activeKey,
      },
      { skip: !activeKey }
    );

  useEffect(() => {
    if (workingAreas && workingAreas.data) {
      allowedTabs = getAllowedTabsByRole(decodedToken.role);
      const tabs = [];
      workingAreas.data.forEach((workingArea) => {
        if (allowedTabs.includes(workingArea.name)) {
          tabs.push({
            label: workingArea.name,
            eventKey: workingArea.id,
            content: <></>,
          });
        }
      });
      setTabsData(tabs);
    }
  }, [workingAreas]);

  useEffect(() => {
    if (tabsData.length > 0) {
      setActiveKey(tabsData[0].eventKey);
    }
  }, [tabsData]);

  useEffect(() => {
    if (activeKey) {
      refetch();
      addQueryParam("activeTab", activeKey);
    }
  }, [date, activeKey, refetch]);

  const addQueryParam = (key, value) => {
    const searchParams = new URLSearchParams(location.search);
    searchParams.set(key, value);
    navigate(`${location.pathname}?${searchParams.toString()}`);
  };

  return (
    <div>
      {isLoading && (
        <div className="loader-container">
          <div className="loader"></div>
        </div>
      )}
      {!isLoading && activeKey && (
        <>
          <div className="overview cmn_card mb-3">
            <div className="overview_header d-flex gap-2 align-items-center">
              <h6 className="mb-0 flex-grow-1">
                {_t("employee_summary", "Employee Summary")}
              </h6>

              <DateSelector setDate={setDate} />
            </div>
            <ul className="m-0 grid_card_wrapper">
              <GridCard
                title={"Total Employee"}
                value={employeeAttendanceSummary?.data?.total_employee}
                icon={KgEntered}
                day={currentDate === date ? _t("today", "Today") : formatDateAndTime(date ,PROJECT_DATE_FORMAT)}
              />
              <GridCard
                title={"Present Employee"}
                value={employeeAttendanceSummary?.data?.present_employee}
                icon={TotalCase}
                day={currentDate === date ? _t("today", "Today") : formatDateAndTime(date ,PROJECT_DATE_FORMAT)}
              />
              <GridCard
                title={"Absent Employee"}
                value={employeeAttendanceSummary?.data?.absent_employee}
                icon={TotalOrangeCase}
                day={currentDate === date ? _t("today", "Today") : formatDateAndTime(date ,PROJECT_DATE_FORMAT)}
              />
            </ul>
          </div>
          <div className="tabs_outer">
            <TabsComponent
              tabs={tabsData}
              defaultKey={activeKey}
              layout="horizontal"
              setActiveKey={setActiveKey}
            />
            <div className="tabs_content">
              <EmployeeAttendenceTab tab={activeKey} />
            </div>
          </div>
        </>
      )}
    </div>
  );
};

export default EmployeeAttendence;
